import { render, staticRenderFns } from "./EmployerRolePermissions.vue?vue&type=template&id=d152e11a&scoped=true"
import script from "./EmployerRolePermissions.vue?vue&type=script&lang=ts"
export * from "./EmployerRolePermissions.vue?vue&type=script&lang=ts"
import style0 from "./EmployerRolePermissions.vue?vue&type=style&index=0&id=d152e11a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d152e11a",
  null
  
)

export default component.exports